export default __webpack_public_path__ + "static/media/training_documents.5985f35d.png";